import { AnimatePresence, motion } from 'framer-motion';
import { formatPhoneNumber } from '../lib/stringFormat';
import { EditUserInfoData } from './EditUserInfo';

interface BottomSheetConfirmOrderProps {
  finalData: EditUserInfoData;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}
export default function BottomSheetConfirmOrder({
  finalData,
  isOpen,
  onClose,
  onSubmit,
}: BottomSheetConfirmOrderProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-80" onClick={onClose}>
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ duration: 0.3 }}
            /* 1. 바텀시트 최대 높이 제한 및 Flex 설정 */
            className="flex max-h-[90vh] w-full flex-col rounded-t-[10px] bg-bg_modal"
            onClick={(e) => e.stopPropagation()} // 내부 클릭 시 닫힘 방지
          >
            {/* 2. Header (고정) */}
            <div className="flex flex-col items-center pb-[32px] pt-[20px]">
              <div className="h-1 w-12 cursor-pointer rounded-full bg-white bg-opacity-20" onClick={onClose} />
            </div>

            <div className="custom-scrollbar flex-1 overflow-y-auto">
              <div className="self-start px-4 text-lg font-semibold leading-[21px] text-white">
                부가서비스 신청 정보
              </div>
              <div className="mt-[14px] self-start px-4 text-xs font-medium leading-[16px] text-text_secondary">
                신청 정보를 확인해주세요
              </div>

              <div className="mt-[20px] h-px bg-btText" />

              {/* 3. Content (스크롤 영역) */}
              <div className="px-5 py-5">
                <div className="mb-5 h-[59px]">
                  <div className="mb-2 text-base font-medium leading-[19px] text-white">구독 이용권</div>
                  <div className="text-xs font-medium text-text_secondary">Security Plus (12,900원/월 요금)</div>
                </div>

                <div className="mb-5 h-[59px]">
                  <div className="mb-2 text-base font-medium leading-[19px] text-white">서비스 내용</div>
                  <div className="text-xs font-medium leading-[16px] text-text_secondary">긴급출동 + 안심보상</div>
                </div>

                <div className="mb-5 h-[59px]">
                  <div className="mb-2 text-base font-medium leading-[19px] text-white">이름</div>
                  <div className="text-xs font-medium leading-[16px] text-text_secondary">{finalData.name}</div>
                </div>

                <div className="mb-5 h-[59px]">
                  <div className="mb-2 text-base font-medium leading-[19px] text-white">휴대전화번호</div>
                  <div className="text-xs font-medium leading-[16px] text-text_secondary">
                    {formatPhoneNumber(finalData.tel)}
                  </div>
                </div>

                <div className="mb-5 h-[59px]">
                  <div className="mb-2 text-base font-medium leading-[19px] text-white">주소 [설치장소]</div>
                  <div className="text-xs font-medium leading-[16px] text-text_secondary">
                    {finalData.address1} {finalData.address2}
                  </div>
                </div>

                <div className="h-[59px]">
                  <div className="mb-2 text-base font-medium leading-[19px] text-white">공동현관 출입번호</div>
                  <div className="text-xs font-medium leading-[16px] text-text_secondary">{finalData.doorNum}</div>
                </div>
              </div>
            </div>

            {/* 4. Buttons (고정) */}
            <div className="flex space-x-2 px-[8px] pb-6">
              <button
                onClick={onClose}
                className="flex-1 rounded-[6px] border bg-bg_inactive py-3 text-base font-semibold text-btText"
              >
                취소
              </button>
              <button
                onClick={onSubmit}
                className="flex-1 rounded-[6px] bg-btPrimary py-3 text-base font-semibold text-btText"
              >
                신청
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}